import styled from 'styled-components';
import Text from '../Text';

type InpputContainerProps = {
  hasError: boolean;
};

export const InputContainer = styled.div<InpputContainerProps>`
  width: inherit;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  .input-styled {
    position: relative;
    display: flex;
    align-items: center;
  }

  input[type='text'],
  input[type='number'] {
    height: 40px;
  }

  input[type='text'],
  input[type='number'],
  textarea {
    width: 100%;
    border: 1px solid var(--color-ebonyClay);
    border-radius: 6px;
    padding: 0 24px;
    font-size: 14px;
    outline: none;
    &:disabled {
      background: var(--color-disabled);
    }
  }

  /* Add padding when leading icon exists */
  .input-styled .leading-icon ~ input {
    padding-left: 40px; /* Adjust this value based on your icon width + desired gap */
  }

  textarea {
    padding: 10px 12px;
    resize: none;
    vertical-align: top;
  }

  .leading-icon {
    position: absolute;
    left: 12px; /* Changed from 4px to 12px for better spacing */
    top: 50%;
    transform: translateY(-50%); /* Centers the icon vertically */
    z-index: 1;
    pointer-events: none; /* Allows clicking through to the input */
    display: flex;
    align-items: center;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  margin-bottom: 4px;

  .mandatory {
    display: inline;
  }
`;

export const HelpText = styled(Text)`
  margin-bottom: 10px;
`;
